import { createSelector } from 'reselect'
import { PeergroupSelectFilterOptions } from 'interfaces/peergroups'
import { metaSelector } from 'selectors/globalSelectors'
import { formatAgeRange, formatCreditRange, formatHousingType, shortenMoneyRange } from 'helpers/formatHelpers'
import { getItemsFromCollection } from 'helpers/normalizeHelpers'
import { HOUSING_TYPES } from 'constants/member'
import { IdRangeEntity } from 'interfaces'

export const peergroupSelectFilterOptionsSelector = createSelector(
  metaSelector,
  (meta): PeergroupSelectFilterOptions => {
    const { peer_ages, peer_creditscores, peer_incomes } = meta

    return {
      age_range: getItemsFromCollection<IdRangeEntity, 'id'>(peer_ages).map((age) => (
        { label: formatAgeRange(age), value: age.id }
      )),
      creditscore_range: getItemsFromCollection<IdRangeEntity, 'id'>(peer_creditscores).map((credit) => (
        { label: formatCreditRange(credit), value: credit.id }
      )),
      income_range: getItemsFromCollection<IdRangeEntity, 'id'>(peer_incomes).map((income) => (
        { label: shortenMoneyRange(income), value: income.id }
      )),
      // TODO extract from meta
      area_type: [
        { label: 'Rural', value: 'rural' },
        { label: 'Suburban', value: 'suburban' },
        { label: 'Urban', value: 'urban' },
      ],
      housing_type: HOUSING_TYPES.map((type) => (
        { label: formatHousingType(type), value: type }
      )),
    }
  },
)
